import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import dayjs from 'dayjs';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { CATEGORY_COLUMNS, DATE_FORMAT_WITH_TIME } from 'lib/constants';
import { categoryStyles } from 'lib/css/categoryTexts';
import { formatRoundedCurrency } from 'lib/utils/FormatUtils';

function GlobalProductsTableCell({ product, column }) {
  const rawValue = product[column];
  const isCategoryColumn = CATEGORY_COLUMNS.includes(column);
  const isDate = column === 'categorized_at' && rawValue;
  const isGmv = column === 'annualized_gmv';

  const displayText = isGmv ? formatRoundedCurrency(rawValue) : rawValue;

  const renderTooltip = props => <Tooltip {...props}>{displayText}</Tooltip>;
  return displayText ? (
    <OverlayTrigger placement="top" overlay={renderTooltip} transition={false}>
      <div className={css(styles.textBox, isCategoryColumn && categoryStyles[column])}>
        {isDate ? dayjs(rawValue).format(DATE_FORMAT_WITH_TIME) : displayText}
      </div>
    </OverlayTrigger>
  ) : null;
}

const styles = StyleSheet.create({
  textBox: {
    maxHeight: 18,
    wordBreak: 'break-word',
  },
});

GlobalProductsTableCell.propTypes = {
  product: PropTypes.object,
  column: PropTypes.string,
};

export default GlobalProductsTableCell;
